"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_aio_view_validateFilter = exports.SHu_aio_view_validFilterOperator = void 0;
exports.SHu_aio_view_validFilterOperator = ["=", "IS NOT NULL", "IS NULL", "IS ANY OF", "IS NONE OF", ">", "<", ">=", "<="];
const SHu_aio_view_validateFilter = (obj) => {
    if (!("column" in obj) || !("operator" in obj))
        return false;
    if (!obj.column || !obj.operator)
        return false;
    if (!exports.SHu_aio_view_validFilterOperator.includes(obj.operator))
        return false;
    if (obj.operator !== "IS NOT NULL" && obj.operator !== "IS NULL" && obj.value == null)
        return false;
    return true;
};
exports.SHu_aio_view_validateFilter = SHu_aio_view_validateFilter;
